import { Waves, Mountain, Utensils, Bed, Car, Info, LucideProps, Train, Plane } from 'lucide-react';
import type { ActivityCategory } from '@/app/lib/types';

interface ActivityIconProps extends LucideProps {
    category?: ActivityCategory;
}

const iconMap: Record<ActivityCategory, React.ElementType> = {
    swim: Waves,
    walk: Mountain,
    food: Utensils,
    lodging: Bed,
    car: Car,
    flight: Plane,
    train: Train,
    other: Info,
    travel: Car, // Default travel to car
};

export function ActivityIcon({ category, ...props }: ActivityIconProps) {
    const Icon = category ? iconMap[category] : iconMap.other;
    return <Icon {...props} />;
}
